import PropTypes from "prop-types"
import React from "react"
import { Chip } from "@material-ui/core"

import useStyles from "./styles"

const EmailChip = ({ email, deleteFunc }) => {
  const classes = useStyles()

  return (
    <Chip
      label={email}
      onDelete={deleteFunc}
      className={classes.emailChip}
      classes={{ deleteIcon: classes.chipIcon, label: classes.label }}
    />
  )
}

EmailChip.propTypes = {
  email: PropTypes.string,
  deleteFunc: PropTypes.func,
}

export default EmailChip
